var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showComponent)?_c('div',{staticClass:"buy-btn-box"},[_c('el-input',{attrs:{"placeholder":"输入购买按钮文字","maxlength":4},model:{value:(_vm.$$FormData.goods_buy_btn_text),callback:function ($$v) {_vm.$set(_vm.$$FormData, "goods_buy_btn_text", $$v)},expression:"$$FormData.goods_buy_btn_text"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }